import { render } from "./SettingsAccount.vue?vue&type=template&id=54f6a2a7&scoped=true"
import script from "./SettingsAccount.vue?vue&type=script&lang=js"
export * from "./SettingsAccount.vue?vue&type=script&lang=js"

import "./SettingsAccount.vue?vue&type=style&index=0&id=54f6a2a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f6a2a7"]])

export default __exports__